export default __webpack_public_path__ + "static/media/all-temples-mahanadi-card-img.e920daae.png";